if (window.location.pathname.includes("/pages/ask-ai-angela-caglia")) {
  const delphiContainer = document.createElement("div");
  delphiContainer.id = "delphi-embed";
  delphiContainer.style.width = "100%";
  delphiContainer.style.maxWidth = "800px";
  delphiContainer.style.margin = "80px auto";
  document.body.appendChild(delphiContainer);

  window.delphi = window.delphi || {};
  window.delphi.page = {
    config: "741295e9-cef6-44b6-a089-2ef646787b2c",
    overrides: {
      landingPage: "OVERVIEW",
    },
    container: {
      selector: "#delphi-embed",
      width: "100%",
      height: "100vh",
    },
  };

  const script = document.createElement("script");
  script.src = "https://embed.delphi.ai/loader.js";
  script.id = "delphi-page-bootstrap";
  document.body.appendChild(script);
}
